<template>
  <vl-properties-list v-vl-spacer:bottom.small>
    <vl-properties-label>{{ $t('geckospecification.detail.id') }}</vl-properties-label>
    <vl-properties-data> {{ props.detail.specificationId }} </vl-properties-data>
    <vl-properties-label>{{ $t('geckospecification.detail.code') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.specificationCode }}</vl-properties-data>
    <vl-properties-label>{{ $t('geckospecification.detail.version') }}</vl-properties-label>
    <vl-properties-data>{{ version }}</vl-properties-data>
    <vl-properties-label>{{ $t('geckospecification.detail.status') }}</vl-properties-label>
    <vl-properties-data>{{ status }}</vl-properties-data>
  </vl-properties-list>
  <div>
    <vl-link mod-icon-before icon="external" mod-no-visited-state :href="datavalidatieUrl" target="_blank">{{
      $t('geckospecification.detail.goToSpecification')
    }}</vl-link>
  </div>
  <div>
    <vl-link mod-icon-before icon="external" mod-no-visited-state :href="datavalidatieTestsUrl" target="_blank">{{
      $t('geckospecification.detail.goToTestOverview')
    }}</vl-link>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { GeckoSpecificationSearchResultDto } from '@/api/backoffice/clients';
import { ENUM_GeckoSpecificationStates } from '@/modules/configuration/common';
import { config } from '@/common/config/config';

const props = defineProps<{
  detail: GeckoSpecificationSearchResultDto;
}>();

const version = computed((): string => {
  return props.detail.versionMajor + '.' + props.detail.versionMinor;
});

const status = computed((): string => {
  const status = Object.values(ENUM_GeckoSpecificationStates).find((x) => x.id == props.detail.specificationStatus);
  return status.name;
});

const datavalidatieUrl = computed((): string | null => {
  const specificationId = props.detail.specificationId;
  return specificationId
    ? `${config.integrations.datavalidatieUrl}/datavalidatie/specification-management/${specificationId}`.toString()
    : null;
});

const datavalidatieTestsUrl = computed((): string | null => {
  return `${datavalidatieUrl.value}/tests`;
});
</script>
